import React from 'react';
import { AffordabilityExcludedState } from 'src/AppState/AffordabilityExcludedState';
import { observer } from 'src/utils/mobx-react';
import { PaginationElements, ParticularNumber, ChevronLeftWrapper, ChevronRightWrapper} from './AffordabilityExcludedRequests.style';

interface PropsType {
    affordabilityExcludedState: AffordabilityExcludedState,
}

export const AffordabilityExcludedPag = observer('AffordabilityExcludedPag', (props: PropsType): React.ReactElement => {
    const { affordabilityExcludedState } = props;    
    const OFFSET = 1;

    return (
        <PaginationElements>
            <ChevronLeftWrapper onClick={(): void => affordabilityExcludedState.handleMove(true)}/>
            {affordabilityExcludedState.pageNumbers.map(number => (
                <ParticularNumber key={number} isSelected={number === affordabilityExcludedState.page}
                    onClick={(): void => affordabilityExcludedState.handleChoosePage(number)}
                >     
                    {number + OFFSET}
                </ParticularNumber>
            ) )}
            <ChevronRightWrapper onClick={(): void => affordabilityExcludedState.handleMove(false)}/>
        </PaginationElements>
    );
});
